<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7813_11892)">
      <path d="M14.6724 4.28142C15.4477 2.50891 17.1422 1.73048 18.8599 2.31264C20.704 2.93689 21.5161 4.81207 20.5005 7.4527C19.9335 8.92693 19.2661 10.9527 19.2661 10.9527C19.2661 10.9527 18.6537 11.7591 18.3831 12.0201C21.3983 13.5605 23.4644 16.7107 23.4644 20.3464C23.4644 21.3314 23.3127 22.2808 23.0316 23.1722L22.0942 29.9066C22.0942 29.9066 15.3442 29.7816 14.7349 29.7816C14.1255 29.7816 4.84424 30.1254 4.84424 20.3464C4.84424 14.4379 8.82861 13.033 10.0005 12.1879C11.1724 11.3428 12.3333 10.0806 12.7974 9.21832C13.5771 7.76947 14.046 5.71343 14.6724 4.28142Z"
            fill="url(#paint0_radial_7813_11892)"
      />
      <path d="M14.6724 4.28142C15.4477 2.50891 17.1422 1.73048 18.8599 2.31264C20.704 2.93689 21.5161 4.81207 20.5005 7.4527C19.9335 8.92693 19.2661 10.9527 19.2661 10.9527C19.2661 10.9527 18.6537 11.7591 18.3831 12.0201C21.3983 13.5605 23.4644 16.7107 23.4644 20.3464C23.4644 21.3314 23.3127 22.2808 23.0316 23.1722L22.0942 29.9066C22.0942 29.9066 15.3442 29.7816 14.7349 29.7816C14.1255 29.7816 4.84424 30.1254 4.84424 20.3464C4.84424 14.4379 8.82861 13.033 10.0005 12.1879C11.1724 11.3428 12.3333 10.0806 12.7974 9.21832C13.5771 7.76947 14.046 5.71343 14.6724 4.28142Z"
            fill="url(#paint1_radial_7813_11892)"
      />
      <path d="M14.6724 4.28142C15.4477 2.50891 17.1422 1.73048 18.8599 2.31264C20.704 2.93689 21.5161 4.81207 20.5005 7.4527C19.9335 8.92693 19.2661 10.9527 19.2661 10.9527C19.2661 10.9527 18.6537 11.7591 18.3831 12.0201C21.3983 13.5605 23.4644 16.7107 23.4644 20.3464C23.4644 21.3314 23.3127 22.2808 23.0316 23.1722L22.0942 29.9066C22.0942 29.9066 15.3442 29.7816 14.7349 29.7816C14.1255 29.7816 4.84424 30.1254 4.84424 20.3464C4.84424 14.4379 8.82861 13.033 10.0005 12.1879C11.1724 11.3428 12.3333 10.0806 12.7974 9.21832C13.5771 7.76947 14.046 5.71343 14.6724 4.28142Z"
            fill="url(#paint2_radial_7813_11892)"
      />
      <path d="M14.6724 4.28142C15.4477 2.50891 17.1422 1.73048 18.8599 2.31264C20.704 2.93689 21.5161 4.81207 20.5005 7.4527C19.9335 8.92693 19.2661 10.9527 19.2661 10.9527C19.2661 10.9527 18.6537 11.7591 18.3831 12.0201C21.3983 13.5605 23.4644 16.7107 23.4644 20.3464C23.4644 21.3314 23.3127 22.2808 23.0316 23.1722L22.0942 29.9066C22.0942 29.9066 15.3442 29.7816 14.7349 29.7816C14.1255 29.7816 4.84424 30.1254 4.84424 20.3464C4.84424 14.4379 8.82861 13.033 10.0005 12.1879C11.1724 11.3428 12.3333 10.0806 12.7974 9.21832C13.5771 7.76947 14.046 5.71343 14.6724 4.28142Z"
            fill="url(#paint3_linear_7813_11892)"
      />
      <path d="M14.6724 4.28142C15.4477 2.50891 17.1422 1.73048 18.8599 2.31264C20.704 2.93689 21.5161 4.81207 20.5005 7.4527C19.9335 8.92693 19.2661 10.9527 19.2661 10.9527C19.2661 10.9527 18.6537 11.7591 18.3831 12.0201C21.3983 13.5605 23.4644 16.7107 23.4644 20.3464C23.4644 21.3314 23.3127 22.2808 23.0316 23.1722L22.0942 29.9066C22.0942 29.9066 15.3442 29.7816 14.7349 29.7816C14.1255 29.7816 4.84424 30.1254 4.84424 20.3464C4.84424 14.4379 8.82861 13.033 10.0005 12.1879C11.1724 11.3428 12.3333 10.0806 12.7974 9.21832C13.5771 7.76947 14.046 5.71343 14.6724 4.28142Z"
            fill="url(#paint4_radial_7813_11892)"
      />
      <path d="M14.6724 4.28142C15.4477 2.50891 17.1422 1.73048 18.8599 2.31264C20.704 2.93689 21.5161 4.81207 20.5005 7.4527C19.9335 8.92693 19.2661 10.9527 19.2661 10.9527C19.2661 10.9527 18.6537 11.7591 18.3831 12.0201C21.3983 13.5605 23.4644 16.7107 23.4644 20.3464C23.4644 21.3314 23.3127 22.2808 23.0316 23.1722L22.0942 29.9066C22.0942 29.9066 15.3442 29.7816 14.7349 29.7816C14.1255 29.7816 4.84424 30.1254 4.84424 20.3464C4.84424 14.4379 8.82861 13.033 10.0005 12.1879C11.1724 11.3428 12.3333 10.0806 12.7974 9.21832C13.5771 7.76947 14.046 5.71343 14.6724 4.28142Z"
            fill="url(#paint5_radial_7813_11892)"
      />
      <path d="M14.6724 4.28142C15.4477 2.50891 17.1422 1.73048 18.8599 2.31264C20.704 2.93689 21.5161 4.81207 20.5005 7.4527C19.9335 8.92693 19.2661 10.9527 19.2661 10.9527C19.2661 10.9527 18.6537 11.7591 18.3831 12.0201C21.3983 13.5605 23.4644 16.7107 23.4644 20.3464C23.4644 21.3314 23.3127 22.2808 23.0316 23.1722L22.0942 29.9066C22.0942 29.9066 15.3442 29.7816 14.7349 29.7816C14.1255 29.7816 4.84424 30.1254 4.84424 20.3464C4.84424 14.4379 8.82861 13.033 10.0005 12.1879C11.1724 11.3428 12.3333 10.0806 12.7974 9.21832C13.5771 7.76947 14.046 5.71343 14.6724 4.28142Z"
            fill="url(#paint6_radial_7813_11892)"
      />
      <path d="M14.6724 4.28142C15.4477 2.50891 17.1422 1.73048 18.8599 2.31264C20.704 2.93689 21.5161 4.81207 20.5005 7.4527C19.9335 8.92693 19.2661 10.9527 19.2661 10.9527C19.2661 10.9527 18.6537 11.7591 18.3831 12.0201C21.3983 13.5605 23.4644 16.7107 23.4644 20.3464C23.4644 21.3314 23.3127 22.2808 23.0316 23.1722L22.0942 29.9066C22.0942 29.9066 15.3442 29.7816 14.7349 29.7816C14.1255 29.7816 4.84424 30.1254 4.84424 20.3464C4.84424 14.4379 8.82861 13.033 10.0005 12.1879C11.1724 11.3428 12.3333 10.0806 12.7974 9.21832C13.5771 7.76947 14.046 5.71343 14.6724 4.28142Z"
            fill="url(#paint7_radial_7813_11892)"
      />
      <path d="M14.6724 4.28142C15.4477 2.50891 17.1422 1.73048 18.8599 2.31264C20.704 2.93689 21.5161 4.81207 20.5005 7.4527C19.9335 8.92693 19.2661 10.9527 19.2661 10.9527C19.2661 10.9527 18.6537 11.7591 18.3831 12.0201C21.3983 13.5605 23.4644 16.7107 23.4644 20.3464C23.4644 21.3314 23.3127 22.2808 23.0316 23.1722L22.0942 29.9066C22.0942 29.9066 15.3442 29.7816 14.7349 29.7816C14.1255 29.7816 4.84424 30.1254 4.84424 20.3464C4.84424 14.4379 8.82861 13.033 10.0005 12.1879C11.1724 11.3428 12.3333 10.0806 12.7974 9.21832C13.5771 7.76947 14.046 5.71343 14.6724 4.28142Z"
            fill="url(#paint8_radial_7813_11892)"
      />
      <path d="M14.6719 4.28239C15.4472 2.50989 17.1417 1.73146 18.8594 2.31362C20.7036 2.93787 21.5156 4.81305 20.5 7.45368C19.933 8.9279 19.2656 10.9537 19.2656 10.9537L18.3826 12.0211C14.0625 14.2188 10 12.1888 10 12.1888C11.1719 11.3438 12.3328 10.0816 12.7969 9.2193C13.5766 7.77044 14.0455 5.71441 14.6719 4.28239Z"
            fill="#EDB8A1"
      />
      <path d="M14.6719 4.28239C15.4472 2.50989 17.1417 1.73146 18.8594 2.31362C20.7036 2.93787 21.5156 4.81305 20.5 7.45368C19.933 8.9279 19.2656 10.9537 19.2656 10.9537L18.3826 12.0211C14.0625 14.2188 10 12.1888 10 12.1888C11.1719 11.3438 12.3328 10.0816 12.7969 9.2193C13.5766 7.77044 14.0455 5.71441 14.6719 4.28239Z"
            fill="url(#paint9_radial_7813_11892)"
      />
      <path d="M14.6719 4.28239C15.4472 2.50989 17.1417 1.73146 18.8594 2.31362C20.7036 2.93787 21.5156 4.81305 20.5 7.45368C19.933 8.9279 19.2656 10.9537 19.2656 10.9537L18.3826 12.0211C14.0625 14.2188 10 12.1888 10 12.1888C11.1719 11.3438 12.3328 10.0816 12.7969 9.2193C13.5766 7.77044 14.0455 5.71441 14.6719 4.28239Z"
            fill="url(#paint10_radial_7813_11892)"
      />
      <path d="M14.6719 4.28239C15.4472 2.50989 17.1417 1.73146 18.8594 2.31362C20.7036 2.93787 21.5156 4.81305 20.5 7.45368C19.933 8.9279 19.2656 10.9537 19.2656 10.9537L18.3826 12.0211C14.0625 14.2188 10 12.1888 10 12.1888C11.1719 11.3438 12.3328 10.0816 12.7969 9.2193C13.5766 7.77044 14.0455 5.71441 14.6719 4.28239Z"
            fill="url(#paint11_radial_7813_11892)"
      />
      <path d="M14.6719 4.28239C15.4472 2.50989 17.1417 1.73146 18.8594 2.31362C20.7036 2.93787 21.5156 4.81305 20.5 7.45368C19.933 8.9279 19.2656 10.9537 19.2656 10.9537L18.3826 12.0211C14.0625 14.2188 10 12.1888 10 12.1888C11.1719 11.3438 12.3328 10.0816 12.7969 9.2193C13.5766 7.77044 14.0455 5.71441 14.6719 4.28239Z"
            fill="url(#paint12_radial_7813_11892)"
      />
      <path d="M14.6719 4.28239C15.4472 2.50989 17.1417 1.73146 18.8594 2.31362C20.7036 2.93787 21.5156 4.81305 20.5 7.45368C19.933 8.9279 19.2656 10.9537 19.2656 10.9537L18.3826 12.0211C14.0625 14.2188 10 12.1888 10 12.1888C11.1719 11.3438 12.3328 10.0816 12.7969 9.2193C13.5766 7.77044 14.0455 5.71441 14.6719 4.28239Z"
            fill="url(#paint13_radial_7813_11892)"
      />
      <rect x="25.8403"
            y="10.918"
            width="5.82021"
            height="9.0435"
            rx="2.9101"
            transform="rotate(90 25.8403 10.918)"
            fill="url(#paint14_radial_7813_11892)"
      />
      <rect x="25.8403"
            y="10.918"
            width="5.82021"
            height="9.0435"
            rx="2.9101"
            transform="rotate(90 25.8403 10.918)"
            fill="url(#paint15_linear_7813_11892)"
      />
      <rect x="25.8403"
            y="10.918"
            width="5.82021"
            height="9.0435"
            rx="2.9101"
            transform="rotate(90 25.8403 10.918)"
            fill="url(#paint16_radial_7813_11892)"
      />
      <rect x="25.125"
            y="24.2812"
            width="5.6636"
            height="7.1875"
            rx="2.8318"
            transform="rotate(90 25.125 24.2812)"
            fill="url(#paint17_radial_7813_11892)"
      />
      <rect x="25.125"
            y="24.2812"
            width="5.6636"
            height="7.1875"
            rx="2.8318"
            transform="rotate(90 25.125 24.2812)"
            fill="url(#paint18_radial_7813_11892)"
      />
      <rect x="25.125"
            y="24.2812"
            width="5.6636"
            height="7.1875"
            rx="2.8318"
            transform="rotate(90 25.125 24.2812)"
            fill="url(#paint19_radial_7813_11892)"
      />
      <rect x="25.125"
            y="24.2812"
            width="5.6636"
            height="7.1875"
            rx="2.8318"
            transform="rotate(90 25.125 24.2812)"
            fill="url(#paint20_radial_7813_11892)"
      />
      <rect x="25.125"
            y="24.2812"
            width="5.6636"
            height="7.1875"
            rx="2.8318"
            transform="rotate(90 25.125 24.2812)"
            fill="url(#paint21_radial_7813_11892)"
      />
      <rect x="25.125"
            y="24.2812"
            width="5.6636"
            height="7.1875"
            rx="2.8318"
            transform="rotate(90 25.125 24.2812)"
            fill="url(#paint22_radial_7813_11892)"
      />
      <rect x="25.125"
            y="24.2812"
            width="5.6636"
            height="7.1875"
            rx="2.8318"
            transform="rotate(90 25.125 24.2812)"
            fill="url(#paint23_radial_7813_11892)"
      />
      <rect x="25.125"
            y="24.2812"
            width="5.6636"
            height="7.1875"
            rx="2.8318"
            transform="rotate(90 25.125 24.2812)"
            fill="url(#paint24_radial_7813_11892)"
      />
      <rect x="26.4531"
            y="20.2188"
            width="5.70313"
            height="9.65679"
            rx="2.85156"
            transform="rotate(90 26.4531 20.2188)"
            fill="url(#paint25_radial_7813_11892)"
      />
      <rect x="26.4531"
            y="20.2188"
            width="5.70313"
            height="9.65679"
            rx="2.85156"
            transform="rotate(90 26.4531 20.2188)"
            fill="url(#paint26_radial_7813_11892)"
      />
      <rect x="26.4531"
            y="20.2188"
            width="5.70313"
            height="9.65679"
            rx="2.85156"
            transform="rotate(90 26.4531 20.2188)"
            fill="url(#paint27_radial_7813_11892)"
      />
      <rect x="26.4531"
            y="20.2188"
            width="5.70313"
            height="9.65679"
            rx="2.85156"
            transform="rotate(90 26.4531 20.2188)"
            fill="url(#paint28_radial_7813_11892)"
      />
      <rect x="26.9102"
            y="15.75"
            width="5.26562"
            height="10.9258"
            rx="2.63281"
            transform="rotate(90 26.9102 15.75)"
            fill="url(#paint29_radial_7813_11892)"
      />
      <rect x="26.9102"
            y="15.75"
            width="5.26562"
            height="10.9258"
            rx="2.63281"
            transform="rotate(90 26.9102 15.75)"
            fill="url(#paint30_radial_7813_11892)"
      />
    </g>
    <defs>
      <radialGradient id="paint0_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(21.3755 21.124) rotate(-180) scale(24.75 22.4375)"
      >
        <stop stop-color="#FFCFCF" />
        <stop offset="0.507576"
              stop-color="#F6C2B1"
        />
        <stop offset="0.689394"
              stop-color="#D49C95"
        />
        <stop offset="1"
              stop-color="#FFDFDA"
        />
      </radialGradient>
      <radialGradient id="paint1_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(14.1548 20.1865) rotate(75.9588) scale(22.0333 22.3239)"
      >
        <stop offset="0.345735"
              stop-color="#D7A284"
              stop-opacity="0"
        />
        <stop offset="0.427604"
              stop-color="#D7A284"
        />
      </radialGradient>
      <radialGradient id="paint2_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(18.938 22.874) rotate(85.3196) scale(10.7233 7.65537)"
      >
        <stop offset="0.529843"
              stop-color="#D49E99"
        />
        <stop offset="1"
              stop-color="#D49E99"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint3_linear_7813_11892"
                      x1="11.3755"
                      y1="30.374"
                      x2="11.3755"
                      y2="19.249"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#BF8496" />
        <stop offset="1"
              stop-color="#BF8496"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint4_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(18.8755 15.5615) rotate(-1.52076) scale(7.06499 5.31174)"
      >
        <stop offset="0.193422"
              stop-color="#985751"
        />
        <stop offset="0.643579"
              stop-color="#CB949C"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint5_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(18.0005 19.6865) rotate(-6.14661) scale(8.17198 7.57925)"
      >
        <stop offset="0.215957"
              stop-color="#985751"
        />
        <stop offset="0.701321"
              stop-color="#CB949C"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint6_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(18.8755 23.0928) rotate(0.753843) scale(7.12562 9.54108)"
      >
        <stop offset="0.287032"
              stop-color="#985751"
        />
        <stop offset="0.569673"
              stop-color="#CB949C"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint7_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.1255 26.6865) rotate(-15.3885) scale(7.06582 7.56448)"
      >
        <stop offset="0.174171"
              stop-color="#985751"
        />
        <stop offset="0.643579"
              stop-color="#CB949C"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint8_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(17.688 11.874) rotate(64.5367) scale(1.45371 3.35617)"
      >
        <stop offset="0.4792"
              stop-color="#FCC8B3"
        />
        <stop offset="1"
              stop-color="#FCC8B3"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint9_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.375 5.375) rotate(114.164) scale(18.0162 6.01602)"
      >
        <stop offset="0.164912"
              stop-color="#FFD3B8"
        />
        <stop offset="0.748557"
              stop-color="#EBAF96"
        />
      </radialGradient>
      <radialGradient id="paint10_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(11.875 1.5) rotate(100.798) scale(12.3436 3.96796)"
      >
        <stop offset="0.801269"
              stop-color="#D49C95"
        />
        <stop offset="1"
              stop-color="#D49C95"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint11_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(13.125 12.7812) rotate(124.242) scale(4.49848 1.81203)"
      >
        <stop offset="0.444359"
              stop-color="#F6C2B2"
        />
        <stop offset="1"
              stop-color="#F6C2B2"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint12_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(18.5625 6.25) rotate(109.612) scale(5.77237 2.36715)"
      >
        <stop stop-color="#FFCFB0" />
        <stop offset="1"
              stop-color="#FFCFB0"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint13_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.1875 4.5625) rotate(83.211) scale(2.64354 2.2987)"
      >
        <stop stop-color="#FFE3C6" />
        <stop offset="1"
              stop-color="#FFE3C6"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint14_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(28.0474 12.8828) rotate(90) scale(7.07812 4.55533)"
      >
        <stop offset="0.0706402"
              stop-color="#FFE2C7"
        />
        <stop offset="0.785872"
              stop-color="#E29F8A"
        />
        <stop offset="1"
              stop-color="#D79B87"
        />
      </radialGradient>
      <linearGradient id="paint15_linear_7813_11892"
                      x1="30.9224"
                      y1="15.0703"
                      x2="29.7349"
                      y2="15.0703"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C98068" />
        <stop offset="0.684211"
              stop-color="#F7CEB6"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint16_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(31.6606 18.8828) rotate(124.356) scale(3.63397 2.0736)"
      >
        <stop offset="0.336779"
              stop-color="#CF8068"
        />
        <stop offset="1"
              stop-color="#CF8068"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint17_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(27.3125 25.4687) rotate(89.2116) scale(6.81315 5.36862)"
      >
        <stop stop-color="#FFE2C7" />
        <stop offset="0.683436"
              stop-color="#E29F8A"
        />
        <stop offset="1"
              stop-color="#D79B87"
        />
      </radialGradient>
      <radialGradient id="paint18_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(31.5312 30.0312) rotate(-97.1135) scale(5.99702 2.40316)"
      >
        <stop stop-color="#B37897" />
        <stop offset="1"
              stop-color="#E29F8A"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint19_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(24.75 38.625) rotate(-82.8317) scale(20.5355 2.09113)"
      >
        <stop offset="0.645549"
              stop-color="#C37A64"
        />
        <stop offset="0.700392"
              stop-color="#E29F8A"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint20_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(28.25 25.9687) rotate(-90) scale(9.96875 7.61503)"
      >
        <stop offset="0.354232"
              stop-color="#C48992"
              stop-opacity="0"
        />
        <stop offset="0.72369"
              stop-color="#C48992"
        />
      </radialGradient>
      <radialGradient id="paint21_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(25.8438 30.5937) rotate(77.3998) scale(5.4436 2.32563)"
      >
        <stop stop-color="#995F5A" />
        <stop offset="1"
              stop-color="#C88984"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint22_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(30.0312 31.4688) rotate(-52.125) scale(3.91935 1.27996)"
      >
        <stop stop-color="#D78867" />
        <stop offset="1"
              stop-color="#D78867"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint23_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(27.375 27.5) rotate(-176.915) scale(5.22632 7.60629)"
      >
        <stop offset="0.507317"
              stop-color="#DE89A6"
              stop-opacity="0"
        />
        <stop offset="0.658154"
              stop-color="#DA849D"
        />
        <stop offset="0.680473"
              stop-color="#E99DA8"
        />
      </radialGradient>
      <radialGradient id="paint24_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(29.1563 31.8125) rotate(-28.3008) scale(3.2298 2.54502)"
      >
        <stop stop-color="#D6875C" />
        <stop offset="1"
              stop-color="#D6875C"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint25_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(28.6158 22.3168) rotate(90) scale(7.55812 4.46369)"
      >
        <stop offset="0.0706402"
              stop-color="#FFE2C7"
        />
        <stop offset="0.785872"
              stop-color="#E29F8A"
        />
        <stop offset="1"
              stop-color="#D79B87"
        />
      </radialGradient>
      <radialGradient id="paint26_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(33.4844 28.2969) rotate(-91.7184) scale(12.5056 3.82019)"
      >
        <stop stop-color="#B76D5F" />
        <stop offset="1"
              stop-color="#E29F8A"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint27_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(30.9844 30.4531) rotate(-53.5194) scale(5.51888 1.68589)"
      >
        <stop stop-color="#D77B5F" />
        <stop offset="1"
              stop-color="#DA7D63"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint28_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(26.9531 29.875) rotate(-89.9187) scale(22.0156 0.968481)"
      >
        <stop offset="0.39245"
              stop-color="#BA7165"
        />
        <stop offset="0.858036"
              stop-color="#E29F8A"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint29_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(28.9069 18.1238) rotate(90) scale(8.55134 4.12127)"
      >
        <stop offset="0.0706402"
              stop-color="#FFE2C7"
        />
        <stop offset="0.785872"
              stop-color="#E29F8A"
        />
        <stop offset="1"
              stop-color="#D79B87"
        />
      </radialGradient>
      <radialGradient id="paint30_radial_7813_11892"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(32.5977 24.3477) rotate(-90) scale(16.625 2.9375)"
      >
        <stop stop-color="#D38673" />
        <stop offset="1"
              stop-color="#E29481"
              stop-opacity="0"
        />
      </radialGradient>
      <clipPath id="clip0_7813_11892">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
